import api from './api';

export const PHONE_HELP = 'Enter a valid number with country code, like +1 514 555 1234.';

// Validation lives on the server so there is exactly ONE parser
// (services/phone_utils.normalize_phone_e164) deciding what Twilio can dial.
// Blank is allowed — these fields are optional; it is BAD input we block.
export const checkPhone = async (raw) => {
    const s = String(raw ?? '').trim();
    if (!s) return { valid: true, e164: null, message: null };
    try {
        const { data } = await api.post('/phone/normalize', { phone: s });
        return { valid: !!data.valid, e164: data.e164 || null, message: data.message || null };
    } catch {
        return { valid: false, e164: null, message: PHONE_HELP };
    }
};
